import {
  OPEN_SIDE_NAV,
  CLOSE_SIDE_NAV,
  SHOW_AUTH_POPUP,
  SET_HEADER_TITLE,
  CHAT_SUCCESS,
  CHAT_FAILURE,
} from './actionType'
import axios from 'axios'
import apiConfig from '../../config/apiConfig'

export function openSideNav() {
  return {
    type: OPEN_SIDE_NAV,
  }
}

export function closeSideNav() {
  return {
    type: CLOSE_SIDE_NAV,
  }
}

export function showAuthPopup(popupType) {
  return {
    type: SHOW_AUTH_POPUP,
    payload: popupType,
  }
}

export function setHeaderTitle(headerTitle) {
  return {
    type: SET_HEADER_TITLE,
    payload: headerTitle,
  }
}

export function getAIChatResponse(messages) {
  return async function (dispatch) {
    try {
      axios.defaults.headers.common['Content-Type'] = 'application/json'

      // Expect messages = [{ role, content }, ...]
      const resp = await axios.post(`${apiConfig.api.url}/chat`, {
        messages,
        stream: false,
      })

      const aiContent =
        resp.data?.response ||
        resp.data?.data?.output?.content ||
        'No content returned.'

      dispatch({
        type: CHAT_SUCCESS,
        payload: { chatResponse: aiContent },
      })

      return aiContent
    } catch (error) {
      const status = error.response?.status
      const msg =
        error.response?.data?.error ||
        error.message ||
        `Request failed${status ? ` (HTTP ${status})` : ''}`

      dispatch({
        type: CHAT_FAILURE,
        error: msg,
      })
      throw new Error(msg)
    }
  }
}
